module.exports = __webpack_public_path__ + "img/p3_12.8d19ec97.png";